// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?protocol=wss%3A&hostname=luxe-web.local&port=3000&pathname=%2Fws&logging=info&overlay=true&reconnect=Infinity&hot=true&live-reload=true");
__webpack_require__("./node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./src/js/index.js");
